import axios from "axios";
import { Base_URL } from "../url";

export const saveCostCenterOfficeMapping = async (mappingData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CostCenterOfficeMapping/CostCenterOfficeMapping?UserName=${username}`,
      mappingData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving cost center office mapping!";
  }
};